export const ASSETS = '/assets';
export const FAVICON_ONETRUST = `${ASSETS}/favicon.png`;
export const FAVICON_ONETRUST_ICO = '/favicon.ico';
export const LOGO_ONETRUST_WHITE = `${ASSETS}/onetrust-logo-white.svg`;
export const BANNER_BLUE = `${ASSETS}/ot-banner-blue.svg`;
